import React,{FC, useState,useRef, useEffect} from 'react'
import {Grid,Theme} from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import DRCallender from './components/DrCallender';
import useFilteredDoctors from '../../../hooks/useFilteredDoctors';
import DRSchedules from './components/DRSchedules';
import useFilteredSchedules from '../../../hooks/useFilteredSchedules';
import { useSession } from 'hooks/SessionProvider';
import { useStore } from 'store/StoreProvider';

const useStyles = makeStyles((theme:Theme) =>
  createStyles({
    DRDetailsMain:{
      backgroundColor:"#fff",
      marginTop:"25px !important",
      [theme.breakpoints.down('sm')]:{
        marginTop:"30px"
      }
    },
      CheckBoxMin:{
        display:"flex",
        alignItems:"center",
        gap:"5px",
        marginTop:theme.spacing(1.2)
      },
      detailsHeaderMain:{
        [theme.breakpoints.up('lg')]:{
          display:"flex",
          height:"115px",
        }, 
      },
      HeaderTitles:{
        color:"#2b2b2b!important",
        fontSize:"1rem !important",
        fontFamily: 'Open Sans !important', 
      },
      searchDropDownMargins:{
        marginTop:theme.spacing(1.5)
      },
      fixMargins:{
        marginTop:"17px"
      },
      filtersMian:{
        [theme.breakpoints.down('sm')]:{
          paddingTop:"25px !important"
        }
      },
      DRSchedules:{
        marginTop:"17px",
        overflow:"auto",
        [theme.breakpoints.down('xl')]:{
          maxHeight:"62%"
        },
        [theme.breakpoints.up('xl')]:{
          maxHeight:"78%"
        },
        [theme.breakpoints.down('md')]:{
          maxHeight:"58vh "
        },
        [theme.breakpoints.down('sm')]:{
          maxHeight:"100% !important"
        }, 
        '&::-webkit-scrollbar': {
      width: '4px', // Width of the scrollbar
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888', // Color of the thumb
      borderRadius: '10px', // Border radius of the thumb
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555', // Color of the thumb when hovered
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1', // Color of the track
    },
      }
  })
);

interface props{
  AppointmentTypes?:any;
  Addresses?:any;
  Providers?:any;
  Schedules?:any;
  AppointmentTypeDoctors?:any
}
const DrDetails:FC<props>=({AppointmentTypes,Addresses,Providers,Schedules,AppointmentTypeDoctors})=> {
  const classes = useStyles();
  const store=useStore();
  const { setActiveStep} = useSession();
  const getAppointmentTypeID = store?.getSelectedDateTime()?.appointmentTypeID ;
  const getLocationID=store?.getSelectedDateTime()?.addressID;
  const getProviderID = Number(store.getDropDowns()?.providerID);
  const [isVirtualVisit, setIsVirtualVisit] = useState<boolean>(false);
  const [schFullLength, setSchFullLength] = useState<boolean>(false);
  const filteredDoctors = useFilteredDoctors(AppointmentTypeDoctors,Providers, getAppointmentTypeID);
  const schedulesList=useFilteredSchedules(Schedules,getLocationID,getProviderID || filteredDoctors?.doctorIds);
  const [inView,setInView]=useState<boolean>(false)
  const scrollTimeout = useRef<NodeJS.Timeout | null>(null); // Ref for debouncing scroll events

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage > 60 && !inView && !schFullLength) {
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
      scrollTimeout.current = setTimeout(() => {
        setInView(true);
      }, 50);
    }
  };
  useEffect(()=>{
    setActiveStep(1)
  },[])
  return (
   <Grid  sx={{height: "100%", overflow: "hidden"}}>
   <Grid className={classes.DRDetailsMain}>

    <Grid className={classes.fixMargins}>
       <DRCallender setIsVirtualVisit={setIsVirtualVisit}></DRCallender>
    </Grid>
   </Grid>

    <Grid className={classes.DRSchedules} onScroll={handleScroll}>
      <Grid item className={classes.fixMargins} >
        <DRSchedules schedules={schedulesList} inView={inView} setInView={setInView} setSchFullLength={setSchFullLength}></DRSchedules>
      </Grid>
    </Grid>

   </Grid>
  )
}

export default DrDetails